import {
    NCoreUIKitLocalize
} from "ncore-ui-kit";
import defaultLocaleJSON from "../../variants/locales/default.json";
import RESTServiceContext from "../../services/restAPI/context";

let cachedProjectLocales = JSON.parse(JSON.stringify(defaultLocaleJSON)) as typeof defaultLocaleJSON;

export const syncSystemLocales = async (targetLanguage?: string): Promise<boolean> => {
    try {
        const lang = targetLanguage || NCoreUIKitLocalize.state?.activeLocale || "tr-TR";

        const response = await RESTServiceContext.actions.getInitialConfigs({
            language: lang
        });

        if(!response || response.code !== 200 || !response.payload || !Array.isArray(response.payload.systemLocales)) {
            return false;
        }

        const locales = response.payload.systemLocales;
        if(locales.length === 0) {
            return false;
        }

        const currentLocales = JSON.parse(JSON.stringify(cachedProjectLocales)) as typeof defaultLocaleJSON;
        let targetIndex = currentLocales.findIndex((item) => item.locale === lang);

        if(targetIndex === -1) {
            targetIndex = currentLocales.findIndex((item) => item.locale === "tr-TR");
        }

        const targetLocale = currentLocales[targetIndex];
        if(!targetLocale || !targetLocale.translations) {
            return false;
        }

        const targetTranslations = targetLocale.translations as unknown as Record<string, string>;

        for(const item of locales) {
            if(
                typeof item?.key === "string" &&
                item.key.trim().length > 0 &&
                typeof item?.value === "string" &&
                item.value.trim().length > 0
            ) {
                targetTranslations[item.key.trim()] = item.value.trim();
            }
        }

        cachedProjectLocales = currentLocales;

        NCoreUIKitLocalize.updateProjectLocales(
            currentLocales as never,
            {
                activeLocale: lang as keyof NCoreUIKit.LocaleKey
            }
        );

        return true;
    } catch {
        return false;
    }
};
export default syncSystemLocales;
